import { Flex, Text, Box } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

export type SortDirection = 'asc' | 'desc' | null;

export interface HeaderCellProps {
  label: string;
  sortable?: boolean;
  sortDirection?: SortDirection;
  onSort?: () => void;
}

export const HeaderCell: React.FC<HeaderCellProps> = ({
  label,
  sortable = false,
  sortDirection = null,
  onSort,
}) => {
  const getSortIcon = () => {
    if (!sortable) return null;

    switch (sortDirection) {
      case 'asc':
        return <Icon w={4} h={4} iconName="sort-up" color="text.darkGray" />;
      case 'desc':
        return <Icon w={4} h={4} iconName="sort-down" color="text.darkGray" />;
      default:
        return <Icon w={4} h={4} iconName="sort" color="text.darkGray" />;
    }
  };

  return (
    <Flex align="center" gap={1}>
      <Text fontWeight="semibold" color="text.darkGray" fontSize="14px">
        {label}
      </Text>
      <Box
        display="flex"
        alignItems="center"
        cursor={sortable ? 'pointer' : 'default'}
        onClick={sortable ? onSort : undefined}>
        {getSortIcon()}
      </Box>
    </Flex>
  );
};
